import { useQueryClient } from "@tanstack/react-query";
import { useGetOne, useUpdate } from "react-admin";
import { order } from "../array";
import type { Order } from "../models";
                                                                                                                                                        
export interface OrderProps {                                                                                                                          
    sellerId: number;                                                                                                                                  
    buyerId: number;                                                                                                                                   
    orderId?: number;                                                                                                                                  
}

export const orderMeta = {
    embed: [
        "...card(card:lastFour)",
        "...zone(zone:name)",
        "buyer:account!FK_buyer(buyer:name,buyerImage:image)",
        "seller:account!FK_seller(seller:name,sellerImage:image)",
        "...account!FK_completed(completed:name,image)",
        "details:order_item(*,details:order_detail(*,...product(brandId,productId,name,variant,type,image)))",
    ],
};
                                                                                                                                                                                                                                                                                    
export const useOrder = ({ sellerId, buyerId, orderId }: OrderProps) => {                                                                       
    const id = `${sellerId}-${buyerId}-${orderId}`;                                                                                                          
    const data = useGetOne<Order>("order", { id, meta: orderMeta }, { enabled: !!orderId, });

    return data ? {
        ...data.data,
        details: order(data.data?.details ?? [], {
            by: x => x.itemId,
            desc: true,
        }),
    } as Order : undefined;
};

export const useOrderMutation = () => {                                                                      
    const queryClient = useQueryClient();                                                                                                                                                                                                           
    const [update] = useUpdate();  
    return (o: Order, x: Partial<Order>) => {
        const id = `${o.sellerId}-${o.buyerId}-${o.orderId}`;  
        return update("order", { id, data: x, previousData: o }, { 
            onSuccess: () => {                                                                                                                             
                queryClient.invalidateQueries({ queryKey: ["order", "getOne", { id: id, meta: orderMeta }] });                                                                                
            }
    })};                                                                                                                                                                                     
};    